























































helpers = require('../../helpers.coffee')

view_model = {
  props: ['company']

  data: ->
    show_dkim: false

  computed:
    plivo_activated: ->
      @company.isPlivo() && @company.plivo_setting?.voip_monthly_plan?

    twilio_activated: ->
      @company.isTwilio() && @company.twilio_setting?.voip_monthly_plan?

  methods:
    verify: ->
      Loader.on()
      new CompaniesResource().verify(@verifySuccess, @unkownError, id: @company.id)

    verifySuccess: (data) ->
      Loader.off()
      @$emit('updated', data.company)

    toggleShowDkim: (event) ->
      return if jQuery(event.target).closest('.clickable-element').length
      @show_dkim = !@show_dkim

    companyEditPath: ->
      "/configuracoes/empresas/#{@company.id}/editar"

    editCompany: ->
      @$router.push path: @companyEditPath()
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/companies/list_item.vue